/** Height of the TrcApp AppBar in px */
export const HEADER_HEIGHT = 121;

/** Top margin applied by TrcApp PageWrapper in px */
export const PAGE_WRAPPER_MARGIN_TOP = 36;
